import React from 'react';
import { useSession } from '@battleops/client/src/context/SessionContext';
import Icon from '../components/Icon';

// What the sync engine (in whichever tab leads) is doing. Click = sync now.
export default function SyncPill({ compact = false }) {
  const { sync, online, syncNow } = useSession();
  let icon = 'cloud'; let color = 'var(--c-success)'; let text = 'Synced';
  if (!online) { icon = 'cloud-off'; color = 'var(--c-text-faint)'; text = sync.pending && !compact ? `Offline · ${sync.pending} waiting` : 'Offline'; }
  else if (sync.state === 'offline') { icon = 'cloud-off'; color = 'var(--c-warning)'; text = compact ? 'No server' : sync.pending ? `Can’t reach server · ${sync.pending}` : 'Can’t reach server'; }
  else if (sync.failed) { icon = 'alert-triangle'; color = 'var(--c-danger)'; text = `${sync.failed} failed`; }
  else if (sync.state === 'syncing') { icon = 'refresh-cw'; color = 'var(--c-text-secondary)'; text = 'Syncing'; }
  else if (sync.pending) { icon = 'upload-cloud'; color = 'var(--c-warning)'; text = `${sync.pending} waiting`; }
  else if (sync.state === 'error') { icon = 'alert-triangle'; color = 'var(--c-warning)'; text = 'Retrying'; }
  return (
    <button onClick={syncNow} title={sync.lastError ? `Last error: ${sync.lastError}` : 'Sync now'}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 5, whiteSpace: 'nowrap', color, fontSize: compact ? 11 : 12, fontWeight: 700 }}>
      <Icon name={icon} size={compact ? 12 : 14} />{text}
    </button>
  );
}
